import ValidateDefaults from 'validation/ValidateDefaults';

export default class ValidateLength extends ValidateDefaults {
    constructor(obj) {
        super(obj);

        this.minLength = obj.options[0];
        this.on = ['blur'];
        this.pageAttrKey = 'validation_length';
    }

    // TODO
    validate(str) {
        if (ValidateDefaults.isEmpty(str)) {
            return true;
        }

        let value = str.trim();

        if (value.length < this.minLength) {
            return false;
        }

        return true;
    }

    static defaultMessage() {
        return ' is too short';
    }
}
